const ACTIONS = {
    CHANGE_LANGUAGE: "CHANGE_LANGUAGE",
    CHANGE_BOT: "CHANGE_BOT",
};

export default ACTIONS;
